






  
  
    window.alert = function() {};
	alert = function() {};
  

  
  
  
    
  
  $('html').addClass('preview-bar-iframe-hide');
  
  
  
  

//Cookies
var transition = 300;

function getCookie(name) {
    var cookie = document.cookie;
    var prefix = name + "=";
    var begin = cookie.indexOf("; " + prefix);
    if (begin == -1) {
        begin = cookie.indexOf(prefix);
        if (begin !== 0) return 0;
    } else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = cookie.length;
        }
    }
  
  console.log('getCookie('+name+'), result: ' + unescape(cookie.substring(begin + prefix.length, end)));
  
    return unescape(cookie.substring(begin + prefix.length, end));
} 

        function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

function checkCookie(cname) {
    var username = readCookie(cname);
  console.log('checkCookie('+cname+')');
    if (username !== '' && username !== null) {
      console.log('cookie is here. Value: '+ readCookie(cname));
return 1;
    } else {
console.log('cookie is not here');
      return 0;
    }
  
}

function deleteCookie(name){
   
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
 
  console.log('deleteCookie('+name+')');
  
}

function setCookie(cname, cvalue) {

 var exdays = "10000";
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  
  console.log('setCookie('+cname+', '+cvalue+')');
}

    
function checkForAttr(attr) {
        if (typeof attr !== typeof undefined && attr !== false) {
            var result = 1;
        } else {
            var result = 0;
        }
  return result;
  
  console.log('checkForAttr('+attr+'); result: ' + result);
  
    }

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
  
  console.log('getUrlParameter('+sParam+'); result:' + sParameterName[1] === undefined ? true : sParameterName[1] );
  
};

  
    function priceToNumber(price) {
        var number = Number(price.replace(/[^0-9\-]+/g, "")) * 100;
      
      console.log('priceToNumber('+price+'); result:' + number);
      
        return number;
    }

    function textToNumber(number) {
        var number = Number(number.replace(/[^0-9\.-]+/g, ""));
      
      console.log('textToNumber('+number+'); result:' + number);
      
        return number;
    }

    function numberToPrice(number) {
      var currency = '£';
        var realPrice = (number / 100).toFixed(2);
        var price = currency + " " + realPrice;
      
      console.log('numberToPrice('+number+'); result:' + price);
      
        return price;
    }

      function randomNum(min, max) {
        console.log('randomNum('+min+', '+max+')');
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
    
    function increment(first, last, elem){
    
    if(first > last){
     var smaller = last;
      var bigger = first;
    }
    else{
     var smaller = first;
      var bigger = last;
    }
   elem.each(function () {
    $(this).prop('Counter',smaller).animate({
        Counter: bigger
    }, {
        duration: 3000,
        easing: 'swing',
        step: function (now) {
            $(this).text(Math.ceil(now));
        }
    });
}); 
  }

    function capitalize(str){
      
    console.log('capitalize('+str+')');
 var result = str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    console.log('capitalize(str): ' + result);
    return result;
}
  
  function camelcase(str) {
    console.log('camelcase('+str+')');
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index == 0 ? match.toLowerCase() : match.toUpperCase();
  });
}
  
    function stringToMath(string){
  
  console.log('stringToMath('+string+'); result: ' + eval(string));
  
return eval(string);
}

    
    Shopify.queue = [];
  
Shopify.moveAlong = function() {   
      var request = Shopify.queue.shift();
            Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
       
      
        ajaxAddSuccess();
      
      console.log('Shopify.moveAlong = function()');
      
    };

        Shopify.updateAlong = function() {
          var request = Shopify.queue.shift();
     Shopify.changeItem(request.variantId, request.quantity, Shopify.updateAlong);
  

    
      console.log('Shopify.updateAlong = function()');
      
        ajaxAddSuccess();
};
  
     Shopify.removeAlong = function() { 
       var request = Shopify.queue.shift();
     Shopify.removeItem(request.variantId, Shopify.updateAlong);
  
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
  }
      else {
      }

          console.log('Shopify.removeAlong = function()');
      
          
};
  
  function updateCartTotal(){
    setTimeout(function(){
 jQuery.getJSON('/cart.js', function(cart) {
    for(var i=0; i<cart.items.length; i++){
      var item = cart.items[i];
      var elem = $('.product-' + item.id+' .money');
      elem.html(Shopify.formatMoney(item.price*item.quantity));
      $('.cart__subtotal').html(Shopify.formatMoney(cart.total_price));
    };
  });
      
    }, 300);
    
    console.log('updateCartTotal()');
      
};

  function updateCartnumber(cart){
    if(cart){
    $('.CartCount').text('(' + cart.item_count + ')');
  }
    else{
    
        setTimeout(function(){
          
 jQuery.getJSON('/cart.js', function(cart) {
  })
       .done(function(cart) {
    

   console.log('updateCartnumber(); qty: ' + cart.item_count + '; #CartCount length: ' + $('#CartCount').length);
   
   
   $('.CartCount').text('(' + cart.item_count + ')');
  })             
    }, 300);
    }
  }
  
    Shopify.addItem = function(id, qty, properties) {
        var params = {
            quantity: qty,
            id: id
        };
        if (properties != false) {
            params.properties = properties;
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: params,
            async: false,
            success: function() {
                ajaxAddSuccess();
              Shopify.moveAlong();
            },
            error: function() {
               consolo.log('Error adding to cart');
            }
        });
    //  $('.cartdrawer').addClass('toggle-cart');
      console.log('Shopify.addItem = function(id, qty, properties)');
      if(window.location.href.indexOf('sample') <= 0 && $(window).width() > 768){
         if( qty > 0) {
        $('.cartdrawer').addClass('toggle-cart'); 
           $('.site-header').addClass('not-transparent');
         }
     }
    }
  
    function removeItem(id) {
push_to_queue(id, 0);
          Shopify.updateAlong();
          
          console.log('removeItem(id); id:' + id);
    
    }

    function push_to_queue(variantID, quantity, properties) {
        Shopify.queue.push({
            variantId: variantID,
            quantity: quantity,
            properties: properties
        });
      console.log('push_to_queue(variantID, quantity, properties), values:'+ variantID +', '+quantity + ', '+ properties);
    
    }

  function clearCart() {
       Shopify.clear(function(){
    console.log('Cart cleared');
  });
      
      console.log('clearCart()');

}
  
function callback() {
        //window.location.href = "/cart";
      console.log('callback()');
    }

    function ajaxAddSuccess(){
    
    $('.item-total-price:not(.upsell-item-total-price), .cart__subtotal').addClass('ajax-loading');
    
			ajaxCartUpdate();
    
    setTimeout(function(){
          
 jQuery.getJSON('/cart.js', function(cart) {
  })
       .done(function(cart) {
   
   console.log('ajax download done');
   updateCartnumber(cart);
    $('.cart__subtotal').text(numberToPrice(cart.total_price));
   $('.cart__subtotal').removeClass('ajax-loading');
   var i;
   
   for(i = 0; i < cart.items.length; i++){
    var itemId = cart.items[i].variant_id;
     
     $('.item-holder[data-id="'+itemId+'"] .item-total-price').text(numberToPrice(cart.items[i].line_price));
   $('.item-holder[data-id="'+itemId+'"] .item-total-price').removeClass('ajax-loading');
     console.log('itemId: ' + itemId);
   }
  })             
    }, 600);
  }

    function render(props) {
  return function(tok, i) { return (i % 2) ? props[tok] : tok; };
}

  function openAjaxCart(){
    if(!$('.ajax-cart-wrapper').hasClass('active')){
    $('.sidebar-filters-holder').removeClass('active');
       
       hideScroll();
         
       $('.mobile-nav--close').trigger('click');
         $('.mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight());
       
         $('.site-header__cart.ajax-cart').addClass('opened');
       
       $('.site-header').addClass('not-transparent');
       
    $('#ajaxCart').toggleClass('active');
       
       $('.main-content').one('click', function(){
         if($('#ajaxCart').hasClass('active')){
        showScroll();
      $('#ajaxCart').removeClass('active');
            $('.site-header__cart.ajax-cart').removeClass('opened');
if(!$('.site-header').hasClass('not-transparent-on-top')){
           $('.template-index .site-header').removeClass('not-transparent');
}
         }
       })
    }
  }

function updateCart(elem, remove){
console.log('updateCart()');
  
  if(remove == 'remove'){
    
    var id = $(elem).parents('.item-holder').data('id');
    
    push_to_queue(id, 0);
    
    Shopify.updateAlong();
    
    $(elem).parents('.item-holder').slideUp(transition);
    
    noProducts(id);
  }
  else{
    
    var id = $(elem).parents('.item-holder').data('id');
  
    console.log('ajax-id: '+ id);
  
    setTimeout(function(){
  
    var  qty = elem.parents('.input__number-holder').find('input').val();   
    
    push_to_queue(id, qty);  
    
      if(qty == 0){
        
        $(elem).parents('.item-holder').slideUp(transition);
        
        noProducts(id);
      }
      
    Shopify.updateAlong();
    
    },300);
    
    
  }
}

function noProducts(id){
  if($('.item-holder:not([data-id="'+id+'"]):visible').length < 1){
   $('#noProducts').slideDown(transition);
  }
}

function updateCartTotal(cart){
  if(cart){
  $('.cart__subtotal').text(numberToPrice(cart.items_subtotal_price));
    }
  else{
  setTimeout(function(){
            jQuery.getJSON('/cart.js', function(cart) {
    $('.cart__subtotal').text(numberToPrice(cart.items_subtotal_price));
            })
  }, 300)
  }              
}

function ajaxCartUpdate(){
var ajaxCartSource =  $('script[data-template="cartItem"]').text().split(/\$\{(.+?)\}/g);
  console.log('ajaxCartUpdate()');
  setTimeout(function(){
    console.log('ajaxCartUpdate() starting');
  jQuery.getJSON('/cart.js', function(cart) {
   // now have access to Shopify cart object
  
})
  .done(function(cart) {
    console.log('getting cart done');
    var cartItems = cart.items.length;
    var titleHtml = $("#ajaxCart .ajax-holder .ajax-cart-title").outerHTML();
      $('.ajax-holder').empty();
     console.log('item in cart out of: '+cartItems);
    var i;
    if(cartItems > 0){
      $('#noProducts').slideUp(300);
    $('#ajaxCart .ajax-holder').append(titleHtml);
      for(i = 0; i<cartItems; i++){
      var item = cart.items[i];
        if(item.image){
       if(item.image.indexOf('.jpg') > -1){
        var img = item.image.replace('.jpg', '_100x100_crop_center.jpg');
      }
      else if(item.image.indexOf('.png') > -1){
        var img = item.image.replace('.png', '_100x100_crop_center.png');
      }
      else if(item.image.indexOf('.gif') > -1){
        var img = item.image.replace('.gif', '_100x100_crop_center.gif');
      }
      else{
         var img = item.image;
      }
        }
        else{
         var img = ''; 
        }
      var itemArr = [{
                title: item.product_title,
                img: img,
                variantId: item.variant_id,
                price: numberToPrice(item.price),
                url: item.url,
         		qty: item.quantity,
        lineItems: item.variant_title
              }];
      
      $('#ajaxCart .ajax-holder').append(itemArr.map(function (item) {
   			    return ajaxCartSource.map(render(item)).join('');
  			  }));
    }
    }
    else{
      $('#ajaxCart .ajax-holder').empty();
       $('#noProducts').slideDown(300);
      $("#ajaxCart .ajax-holder .ajax-cart-title").slideUp(300);
    }
    openAjaxCart();
    updateCartTotal(cart);
    updateCartnumber(cart.quantity);
  });
    console.log('AjaxCartUpdate');
  }, 800)
}

function hideAjaxCart(){
        showScroll();
      $('#ajaxCart').removeClass('active');
            $('.site-header__cart.ajax-cart').removeClass('opened');
if(!$('.site-header').hasClass('not-transparent-on-top')){
           $('.template-index .site-header').removeClass('not-transparent');
}
}
    
    function checkCheckbox(elem) {

        if (!elem.is(':checked')) {
            elem.parents('.item').removeClass('success').addClass('error');
            console.log(invalid + ' invalid');
            return 1;

        } else {
            elem.parents('.item').addClass('success').removeClass('error');
            return 0;

        }

console.log('checkCheckbox(elem)');
    }

    function checkEmail(elem) {

        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

        var val = elem.val();

        if (!emailReg.test(val) || val == '') {

            elem.removeClass('success').addClass('error');

            return 1;

        } else {

            elem.addClass('success').removeClass('error');

            return 0;

        }
console.log('checkEmail(elem)');

    }

    function checkPattern(elem) {

        if (elem.is(":invalid")) {

            elem.removeClass('success').addClass('error');

            return 1;
        } else {

            elem.addClass('success').removeClass('error');

            return 0;
        }

console.log('checkPattern(elem)');
    }

    function checkTextInputs(elem) {

        var val = elem.val().replace(/ /g, '');

        if (val == undefined || val == 'undefined' || val.length == 0) {

            elem.removeClass('success').addClass('error');
            return 1;
        } else {

            elem.addClass('success').removeClass('error');

            return 0;

        }

console.log('checkTextInputs(elem)');
    }

    function checkRequired(elem) {

        var parent = elem.parents('form');

        parent.find('input[required]:not([type="checkbox"]):not([type="email"]):not([pattern]):visible').each(function() {

            checkTextInputs($(this));

        })

        parent.find('input[type="checkbox"][required]:visible').each(function() {

            checkCheckbox($(this));
        })

        parent.find('input[type="email"][required]:visible').each(function() {

            checkEmail($(this));

        })

        parent.find('input[pattern][required]:visible').each(function() {

            checkPattern($(this));

        })

        invalid = parent.find('.error').length;

        console.log(invalid + ' invalid');
        if (invalid > 0) {

            if (invalid == 0) {
                $('.add-to-cart')
                    .text(addToCartText)
                    .removeClass('disabled');
            } else {
                $('.add-to-cart')
                    .text(addToCartError)
                    .addClass('disabled');
            }

            parent.find('.errors-wrapper,  .errors-wrapper .empty-fields').removeClass('hide');

            console.log('Empty fields: ' + invalid);

            parent.find('.error[required][pattern]').change(function() {
                console.log(invalid + ' invalid');

                checkPattern($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }
                console.log(invalid);

            })

            parent.find('.error[required][type="email"]').change(function() {
                console.log('email changed');
                checkEmail($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }
                console.log(invalid);

            })

            parent.find('.error[required][type="checkbox"]').change(function() {
                console.log('checkbox changed');
                checkCheckbox($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }
                console.log(invalid);

            })

            parent.find('.error[required]:not([type="checkbox"]):not([type="email"]):not([pattern]):visible').change(function() {
                console.log('inputText changed');
                checkTextInputs($(this));
                invalid = $(this).parents('form').find('.error').length;

                if (invalid == 0) {
                    $('.add-to-cart')
                        .text(addToCartText)
                        .removeClass('disabled');
                } else {
                    $('.add-to-cart')
                        .text(addToCartError)
                        .addClass('disabled');
                }

                console.log(invalid);

            })

        }

        return invalid;
      
      
console.log('checkRequired(elem)');
    }

//preventing input number to surpass the min and max values
    
    $('input[type="number"]').bind('input', function(){
      
      var clearedValue = $(this).val().replace(/^0+/, '');
      
      if( $(this).val() !== clearedValue){
        $(this).val(clearedValue);
      }
      
      if($(this).val() > Number( $(this).attr('max'))){
        $(this).val($(this).attr('max'));
      }
      else if($(this).val() < Number( $(this).attr('min'))){
        $(this).val($(this).attr('min'));
      } 
      
      console.log("$('input[type='number']').bind('input', function(){}");
    })

    
function fadeEffects(hideElem, showElem){
      
      if(hideElem.length > 0){
  hideElem.fadeOut(300);
    
    setTimeout(function(){
      if(showElem.length > 0){
      showElem.fadeIn(300);
      }
    }, 300)
      }
      else{
        showElem.fadeIn(300);
      }
     console.log('fadeEffects(hideElem, showElem)');
    
}

function slideEffects(hideElem, showElem){
  if(hideElem.length > 0){
  hideElem.slideUp(300);
  }
showElem.slideDown(300);
console.log('slideEffects(hideElem, showElem)');
    
}
  
function typeWriter(elem, txt, repeat) {
    var i = 0;
  if(txt == ''){
  var txt = $(elem).text();
  }
var speed = 150; /* The speed/duration of the effect in milliseconds */

  elem.addClass('typewriter');
  
  function typeWrite(){
  if (i < txt.length > 0){
    $(id).html($(elem).html() + '' + txt.charAt(i));
    i++;
                            
     if( $(elem).text() == txt)   {
       if(repeat != 0){
               i = 0;
                            setTimeout(function(){
                              $(elem).text('')
    i = 0;
      typeWriter();
    }, 2000);
       }
       }
       else{
    var x = setTimeout(typeWrite, speed);
  }
  }
}
}

    function smoothLoad(){
//requires css body.loading: opacity: 0;
      $('body').removeClass('loading');

window.onbeforeunload = function(){

    
 $('body').addClass('loading');
 
  
}

console.log('smoothLoad()');
}

  //smooth scroll if internal link
  
    $(document).on('click', 'a', function(e){
    if($(this).attr('href').indexOf('#') == 0 && $(this).attr('href').length > 1 && $($(this).attr('href')).length > 0){
      
        
      if($(e.target).is('.instafeed-overlay') || location.hash.includes("-insta-feed")){ 
        return;
      }
      
      e.preventDefault();

      if($('.site-header').hasClass('fixed-header')){
        var scrolltop = $($(this).attr('href')).offset().top - $('.site-header').height() - $('.about-navigation').height() + 1;
      }
      else{
        var scrolltop =   $($(this).attr('href')).offset().top - 180;
      }
      $('html, body').animate({ scrollTop: scrolltop}, 300);
      return false;
    }
  })

    function parallax(){
    console.log('parallax: ' + $('.parallax').length);
  
  if($('.parallax').length > 0){
    $('.parallax').each(function(){
      
    var scrolled = $(window).scrollTop() - $(this).offset().top;

      $(this).css('background-position',"0 "+  (scrolled * 1) + 'px');
    })
      

  $(window).scroll(function(e){
      $('.parallax').each(function(){
      
    var scrolled = $(window).scrollTop() - $(this).offset().top;

      $(this).css('background-position',"0 "+  (scrolled * 1) + 'px');
    })
  });
  }
  }
  
  
  var usedHideScroll = 0;
  
    var scrollValue = 0;

    function hideScroll(){
      scrollValue = $(document).scrollTop();
      $('html, body').addClass('no-overflow').css('top', -scrollValue).css('position', 'fixed');
      
      console.log('function hideScroll()');
      
      usedHideScroll = 1;
    }
    
       function showScroll(){
         $('html, body').css('position', 'inherit').removeClass('no-overflow').css('top', 0);
         
         $('html, body').animate({
        scrollTop: scrollValue},
        0);
         console.log('function showScroll()');
         
         usedHideScroll = 0;
      }
  
  function toggleScroll(){
    if($('html').hasClass('no-overflow')){
      showScroll();
    console.log('toggleScroll(); showing scroll');
    }
    else{
      hideScroll();
    console.log('toggleScroll(); hiding scroll');
    }
    
  }
  
  function transparentHeader(){
    
    console.log('transparentHeader(); usedHideScroll: ' + usedHideScroll);
    
    if(usedHideScroll == 0){
      
    if($(document).scrollTop() > 60 ){
        
        $('.site-header').removeClass('transparent');
            
      }
      
      else{
           
        $('.site-header').addClass('transparent');
         
      }
    
    $(window).scroll(function(){
      
      console.log('$(window).scroll(function()) inside transparentHeader(); usedHideScroll: ' + usedHideScroll);
    
      
      if(usedHideScroll == 0){
      
      if($(document).scrollTop() > 60 ){
        
        $('.site-header').removeClass('transparent');
            
      }
      
      else{
           
        $('.site-header').addClass('transparent');
         
      }
      
      }
        
    })
    
    
console.log('transparentHeader()');
    }
  }
  
  function toggleHeaderPadding(){
  
    if($('.site-header').hasClass('smallable')){
    
    if(usedHideScroll == 0){
      
    if($(document).scrollTop() > 60 ){
        $('.site-header .dynamic-height .site-nav>li').removeClass('padding-vertical-xlg').addClass('padding-vertical-md');
      $('.site-header .dynamic-height').removeClass('small--padding-vertical-md').addClass('small--padding-vertical-sm2');
      
    }
      
      else{
        $('.site-header .dynamic-height .site-nav>li').addClass('padding-vertical-xlg').removeClass('padding-vertical-md');
      $('.site-header .dynamic-height').removeClass('small--padding-vertical-sm2').addClass('small--padding-vertical-md');
        
      }
      
      }
    
    $(window).scroll(function(){
      
      console.log('$(window).scroll(function()) inside transparentHeader(); usedHideScroll: ' + usedHideScroll);
    
      
     if(usedHideScroll == 0){
      
    if($(document).scrollTop() > 60 ){
        $('.site-header .dynamic-height .site-nav>li').removeClass('padding-vertical-xlg').addClass('padding-vertical-md');
      $('.site-header .dynamic-height').removeClass('small--padding-vertical-md').addClass('small--padding-vertical-sm2');
      
    }
      
      else{
        $('.site-header .dynamic-height .site-nav>li').addClass('padding-vertical-xlg').removeClass('padding-vertical-md');
      $('.site-header .dynamic-height').removeClass('small--padding-vertical-sm2').addClass('small--padding-vertical-md');
        
      }
      
      }
   
    })
 
    }
console.log('toggleHeaderPadding()');
    }

   function announceBarFunctions() {
  if($('.site-header').hasClass('fixed-header') && !$('.site-header').hasClass('transparent')){
    var backgroundColor = $('.site-header').css('background');
    
    
    $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight());
    $('.announcement-bar .close-announcement').click(function(){
      $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight() - $('.announcement-bar:visible').outerHeight())
     $('.site-header').removeClass('small--no-border-bottom').addClass('small--border-bottom');
    })
  }
      else{
        $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight());
    $('.announcement-bar .close-announcement').click(function(){
      $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight() - $('.announcement-bar:visible').outerHeight())
     $('.site-header').removeClass('small--no-border-bottom').addClass('small--border-bottom');
    })
      }
      console.log('announceBarFunctions()');
      
      $(window).resize(function(){
        setTimeout(function(){
        if($('.site-header').hasClass('fixed-header') && !$('.site-header').hasClass('transparent')){
    var backgroundColor = $('.site-header').css('background');
    
    
    $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight());
    $('.announcement-bar .close-announcement').click(function(){
      $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight() - $('.announcement-bar:visible').outerHeight())
     $('.site-header').removeClass('small--no-border-bottom').addClass('small--border-bottom');
    })
  }
      else{
        $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight());
    $('.announcement-bar .close-announcement').click(function(){
      $('.sidebar-filters-holder, .not-transparent-on-top-holder, .mobile-nav-wrapper:not(.move-body), .ajax-cart-wrapper').css('padding-top', $('.site-header').outerHeight() - $('.announcement-bar:visible').outerHeight())
     $('.site-header').removeClass('small--no-border-bottom').addClass('small--border-bottom');
    })
      }
      console.log('announceBarFunctions()');
        },300);
      })
}
  
  
  
  //date functions
  
     function compareToToday(dateText) {
// date is dd.mm.yyyy
        var inputDate = dateText.split(".");
        var today = new Date();
        inputDate = new Date(inputDate[2], inputDate[1] - 1, inputDate[0], 0, 0, 0, 0);
        today = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
       
       console.log('compareToToday('+dateText+'); result: ' + inputDate < today );
       
        return inputDate < today;
          //inputDate < today, if true, result is 'False'
};

     function compareDates(date1, date2) {
// date is dd.mm.yyyy
        var inputDate1 = date1.split(".");
var inputDate2 = date2.split(".");
        inputDate1 = new Date(inputDate1[2], inputDate1[1] - 1, inputDate1[0], 0, 0, 0, 0);
        inputDate2 = new Date(inputDate2[2], inputDate2[1] - 1, inputDate2[0], 0, 0, 0, 0);
       
       console.log('compareDates('+date1+', '+date2+'); result: '+ inputDate1 < inputDate2);
       
       
        return inputDate1 < inputDate2;
          //date1 < date2, if true, result is 'False'
};

//distance between dates

  function daysDistance(firstDate,secondDate){
                
                 var startDay = new Date(firstDate);
                  var endDay = new Date(secondDate);
                  var millisecondsPerDay = 1000 * 60 * 60 * 24;

                  var millisBetween = startDay.getTime() - endDay.getTime();
                  var days = millisBetween / millisecondsPerDay;

                  // Round down.
                  return Math.abs( Math.floor(days));
    
    console.log('daysDistance('+firstDate+','+secondDate+'); result: ' + Math.abs( Math.floor(days)));
       
}

    function dateToWeekday(date){
      var d = new Date(date);
var weekday = new Array(7);
weekday[0] =  "Sunday";
weekday[1] = "Monday";
weekday[2] = "Tuesday";
weekday[3] = "Wednesday";
weekday[4] = "Thursday";
weekday[5] = "Friday";
weekday[6] = "Saturday";

      console.log('dateToWeekday('+date+')');
      
return weekday[d.getDay()];
    }
    
      
  
  
function copyToClipboard(element) {
 var $temp = $("<input>");
 $("body").append($temp);
 $temp.val($(element).val()).select();
 document.execCommand("copy");
 $temp.remove();
  
  console.log('copyToClipboard(element)');
  
}
  
function scrollToDiv(element){
  var headerHeight = 0;
  
  if($('.site-header').css('position') == 'fixed'|| $('.site-header__mobile-nav').css('position') == 'fixed'){
   headerHeight =  $('.site-header').outerHeight();
    console.log('has Fixed');
  }
  console.log('scrollin');
  $('html, body').animate({
        scrollTop: element.offset().top - headerHeight},
        300);
  
  console.log(element.offset().top);
  
   console.log('scrollToDiv(element)');
  
  }

  //parallax background effect

    function scrollLoad(objClass, shown){
    var step = shown + 1;
    var topOffset = $(objClass).offset().top;
    var height = $(objClass).height();
    var totalOffset = topOffset + height - $(window).height()*2;
    console.log('offset: ' + topOffset);
    
     var css = '<style>'+objClass+'>div:nth-child(n+'+step+')){display: none}</style>';
    
    $(window).scroll(function(){
      var top = $(window).scrollTop();
      
      console.log('compare: ' +top+'---'+ totalOffset +'shown: ' + shown +'-- total:' + $(''+objClass+'>div').length);
      
      if(top > totalOffset && $('.stamped-reviews-widget>div').length > shown ){
        
        console.log('new reviews showing: ' + $(''+objClass+'>div:hidden:not(:nth-child(n+'+( shown + step )+'))').length);
        $(''+objClass+'>div:hidden:not(:nth-child(n+'+( shown + step )+'))').slideDown(300);
        shown = shown + step;
      }
      
      height = $(objClass).height();
    totalOffset = topOffset + height - $(window).height();
    })
  }
  
  //custom modal
  
  function customModalShow(cookie, modal){
    console.log('modalClass: ' + modal.attr('class').replace(/\s/g, ''));
    if(cookie == 'cookie'){
     
      if(checkCookie(modal.attr('class').replace(/\s/g, '')) == 1){
       console.log('customModalShow('+cookie+'); opened: opened');
        
        return 'opened';
        
        
      }
      else{
        setCookie(modal.attr('class').replace(/\s/g, ''));
        
        hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+'); opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+');opened: opening');
        
        return 'opening';
        
        
      }
      
    }
    else{
      
      hideScroll();
        
        fadeEffects('',modal);
        
           console.log('customModalShow('+cookie+');opened: opening');
        
        
        $('.modal__close').click(function(){
        closeModal(modal);
        })
        console.log('customModalShow('+cookie+'); opened: opening');
        
        return 'opening';
        
        
      
    }
    
  }
  
  function closeModal(elem){
   fadeEffects(elem, ''); 
    showScroll();
  }

        function hideAllModals(){
    $('.modal__overlay').fadeOut(300);
      if(usedHideScroll == 1){
    showScroll();
      }
    }
      //same height of elements
  
  function sameHeight(obj, child){
    obj.css('height', 'auto');
    var maxHeight = 0;
    obj.each(function(){
      if($(this).outerHeight() > maxHeight){
        maxHeight = $(this).outerHeight();
        console.log('bigger height: ' + maxHeight +'---'+$(this).outerHeight())
      }
      else{
       console.log('height not bigger: ' + maxHeight +'---'+$(this).outerHeight())
       
      }
      
    })
    obj.css('height', maxHeight);
    
    obj.each(function(){
      var diff = ($(this).height() - $(this).find('.'+child+'').outerHeight())/2;
      
      $(this).find('.'+child+'').css('top', diff);
    })
    
    console.log('sameHeight(obj, child)');
  }
 
  //check if fixed elem is over static one 
  
  function checkScrollOver(elem, elem2){
    var elemOffset = elem.offset().top;
    
    if(elem2 !== undefined){
      var elem2Offset = elem2.offset().top + elem2.outerHeight();
      
     if(elem2Offset > elemOffset){
      
      console.log('checkScrollOver(elem) = 1');
     return 1; 
    }
    else{
      console.log('checkScrollOver(elem) = 0 with elemOffset = ' + elemOffset + ' and scrollTop: ' + elem2Offset);
     return 0; 
    }
    }
    else{
    if($(document).scrollTop() > elemOffset){
      
      console.log('checkScrollOver(elem) = 1');
     return 1; 
    }
    else{
      console.log('checkScrollOver(elem) = 0 with elemOffset = ' + elemOffset + ' and scrollTop: ' + $(document).scrollTop());
     return 0; 
    }
    }
  }
  
    //if element is visible on the screen
  
  function isScrolledIntoView(elem){
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}
//hide context menu
  
  function hideContextMenu(obj){
    
     function absorbEvent_(event) {
      var e = event || window.event;
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
      e.cancelBubble = true;
      e.returnValue = false;
      return false;
    }

    function preventLongPressMenu(node) {
      node.ontouchstart = absorbEvent_;
      node.ontouchmove = absorbEvent_;
      node.ontouchend = absorbEvent_;
      node.ontouchcancel = absorbEvent_;
    }

      preventLongPressMenu(obj);
   
  }
  


  function screenResolution(){
 var ratio = window.devicePixelRatio || 1;
var is_touch_device = 'ontouchstart' in document.documentElement;
var touch_status = (is_touch_device) ? 'touch' : 'no-touch';
touch_status = ' ts:' + touch_status;
var width_height = 'wh:' + screen.width + 'x' + screen.height;
var client_width_height = ' cwh:' + document.documentElement.clientWidth + 'x' + document.documentElement.clientHeight;
var rw = screen.width * ratio;
var rh = screen.height * ratio;
var ratio_width_height = ' r:' + ratio + ' rwh:' + rw + 'x' + rh;
var data_string = width_height + client_width_height + ratio_width_height + touch_status; 
    
    return data_string;
}
  function getMobileOperatingSystem(){
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "androidInfo";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iphoneInfo";
    }

    return "desktopInfo";
}
  
  function getiPhoneModel() {
    // Create a canvas element which can be used to retrieve information about the GPU.
    var canvas = document.createElement("canvas");
    if (canvas) {
        var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (context) {
            var info = context.getExtension("WEBGL_debug_renderer_info");
            if (info) {
                var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
            }
        }
    }

    // iPhone X/Xs
    if ((window.screen.height / window.screen.width == 812 / 375) && (window.devicePixelRatio == 3)) {
        switch (renderer) {
            default:
                return "iPhone X or Xs";
            case "Apple A11 GPU":
                return "iPhone X";
            case "Apple A12 Bionic":
                return "iPhone Xs";
        }
      
      //iPhone Xs Max/Xr
      
    } else if(window.screen.height / window.screen.width == 896 / 414){
      
      if(window.devicePixelRatio == 3){
        return "iPhone Xs Max";
      }
      else if(window.devicePixelRatio == 2){
      return "iPhone Xr";
      }
    // iPhone 6+/6s+/7+ and 8+
    } else if ((window.screen.height / window.screen.width == 736 / 414) && (window.devicePixelRatio == 3)) {
        switch (renderer) {
            default:
                return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus";
            case "Apple A8 GPU":
                return "iPhone 6 Plus";
            case "Apple A9 GPU":
                return "iPhone 6s Plus";
            case "Apple A10 GPU":
                return "iPhone 7 Plus";
            case "Apple A11 GPU":
                return "iPhone 8 Plus";
        }
    // iPhone 6+/6s+/7+ and 8+ in zoom mode
    } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 3)) {
        switch(renderer) {
            default:
                return "iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus (display zoom)";
            case "Apple A8 GPU":
                return "iPhone 6 Plus (display zoom)";
            case "Apple A9 GPU":
                return "iPhone 6s Plus (display zoom)";
            case "Apple A10 GPU":
                return "iPhone 7 Plus (display zoom)";
            case "Apple A11 GPU":
                return "iPhone 8 Plus (display zoom)";
        }
    // iPhone 6/6s/7 and 8
    } else if ((window.screen.height / window.screen.width == 667 / 375) && (window.devicePixelRatio == 2)) {
        switch(renderer) {
            default:
                return "iPhone 6, 6s, 7 or 8";
            case "Apple A8 GPU":
                return "iPhone 6";
            case "Apple A9 GPU":
                return "iPhone 6s";
            case "Apple A10 GPU":
                return "iPhone 7";
            case "Apple A11 GPU":
                return "iPhone 8";
        }
    // iPhone 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
    } else if ((window.screen.height / window.screen.width == 1.775) && (window.devicePixelRatio == 2)) {
        switch(renderer) {
            default:
                return "iPhone 5, 5C, 5S, SE or 6, 6s, 7 and 8 (display zoom)";
            case "PowerVR SGX 543":
                return "iPhone 5 or 5c";
            case "Apple A7 GPU":
                return "iPhone 5s";
            case "Apple A8 GPU":
                return "iPhone 6 (display zoom)";
            case "Apple A9 GPU":
                return "iPhone SE or 6s (display zoom)";
            case "Apple A10 GPU":
                return "iPhone 7 (display zoom)";
            case "Apple A11 GPU":
                return "iPhone 8 (display zoom)";
        }
    // iPhone 4/4s
    } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 2)) {
        switch(renderer) {
            default:
                return "iPhone 4 or 4s";
            case "PowerVR SGX 535":
                return "iPhone 4";
            case "PowerVR SGX 543":
                return "iPhone 4s";
        }
    // iPhone 1/3G/3GS
    } else if ((window.screen.height / window.screen.width == 1.5) && (window.devicePixelRatio == 1)) {
        switch(renderer) {
            default:
                return "iPhone 1, 3G or 3GS";
            case "ALP0298C05":
                return "iPhone 3GS";
            case "S5L8900":
                return "iPhone 1, 3G";
        }
    } else {
        return "Not an iPhone";
    }
}
  function iOSversion() {
		if (/iP(hone|od|ad)/.test(navigator.platform)) {
			// supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
			var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
			return [parseInt(v[1], 10) + '.' + parseInt(v[2], 10) + '.' + parseInt(v[3] || 0, 10)];
		}
	}
  function iphoneInfo(){

  var model = getiPhoneModel();
  
     var version = iOSversion();
  
  return model + ';' + version;
}
  function getAndroidVersion(ua){
    ua = (ua || navigator.userAgent).toLowerCase(); 
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : undefined;
} 
  function androidInfo(){
  
  var version = getAndroidVersion(ua);
  
  return version;
}
  function desktopInfo() {
    'use strict';
    
    var module = {
        options: [],
        header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
        dataos: [
            { name: 'Windows', value: 'Win', version: 'NT' },
            { name: 'Macintosh', value: 'Mac', version: 'OS X' },
            { name: 'Linux', value: 'Linux', version: 'rv' },
            { name: 'Palm', value: 'Palm', version: 'PalmOS' }
        ],
        databrowser: [
            { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
            { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
            { name: 'Safari', value: 'Safari', version: 'Version' },
            { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
            { name: 'Opera', value: 'Opera', version: 'Opera' },
            { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
        ],
        init: function () {
            var agent = this.header.join(' '),
                os = this.matchItem(agent, this.dataos),
                browser = this.matchItem(agent, this.databrowser);
            
            return { os: os, browser: browser };
        },
        matchItem: function (string, data) {
            var i = 0,
                j = 0,
                html = '',
                regex,
                regexv,
                match,
                matches,
                version;
            
            for (i = 0; i < data.length; i += 1) {
                regex = new RegExp(data[i].value, 'i');
                match = regex.test(string);
                if (match) {
                    regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                    matches = string.match(regexv);
                    version = '';
                    if (matches) { if (matches[1]) { matches = matches[1]; } }
                    if (matches) {
                        matches = matches.split(/[._]+/);
                        for (j = 0; j < matches.length; j += 1) {
                            if (j === 0) {
                                version += matches[j] + '.';
                            } else {
                                version += matches[j];
                            }
                        }
                    } else {
                        version = '0';
                    }
                    return {
                        name: data[i].name,
                        version: parseFloat(version)
                    };
                }
            }
            return { name: 'unknown', version: 0 };
        }
    };
    
    var e = module.init(),
        debug = '';
    
    debug +=  e.os.name + ';';
    debug +=  e.os.version + ';';
    debug +=  e.browser.name + ';';
    debug +=  e.browser.version;
       
  return debug;
}
  function userInfo(){

  var userInfo = '';
  
  var functionToActivate = getMobileOperatingSystem();
  
  console.log('functionToActivate: '+functionToActivate);
  
  if(functionToActivate != "Windows Phone"){
   userInfo = window[functionToActivate]();
  }

    userInfo += ';' + screenResolution();
  alert('userInfo: ' + userInfo);
}



function hideNav(){
 showScroll();
          $('html').removeClass('nav-opened');
          $('.mobile-nav-wrapper').removeClass('js-menu--is-open');
          $('.js-mobile-nav-toggle').removeClass('mobile-nav--close');
          if(!$('.site-header').hasClass('not-transparent-on-top')){
          $('.template-index .site-header').removeClass('not-transparent');
          }
}

function swipeFunctions(direction){
  
      if($('html').hasClass('nav-opened') && direction == 'left'){
     hideNav();
    }
      
      if($('#ajaxCart').hasClass('active') && direction == 'right'){
        hideAjaxCart();
      }
}

var direction = '';

    $("html")
    .on('mousedown touchstart', function (e) {
            xDown = e.pageX || e.originalEvent.touches[0].pageX;
            yDown = e.pageY || e.originalEvent.touches[0].pageY;
            console.log("(x,y) = (" + xDown + "," + yDown +")");
        })
        .on('mouseup touchend',function (e) {
            xUp = e.pageX || e.originalEvent.changedTouches[0].pageX;
            yUp = e.pageY || e.originalEvent.changedTouches[0].pageY;
            console.log("(x,y) = (" + xUp + "," + yUp +")");
            if (xDown != xUp || yDown != yUp) {
                console.log('Swiped');   
            }
      if(Math.abs((yDown - yUp)) > 50 || Math.abs((xDown - xUp)) > 50){
    if(Math.abs((yDown - yUp)) > Math.abs((xDown - xUp))){
        
          console.log('Vertical swipe');
        
        if(yDown > yUp){
         console.log('up');
         direction = 'up';
        }
        else{
          console.log('swipe down');
          direction = 'down' ;
        }
      }
      else{
        console.log('Horzontal swipe');
        
        if(xDown > xUp){
         console.log('swipe left');
         direction = 'left' ;
        }
        else{
          console.log('swipe right');
          direction = 'right' ;
        }
      }
      console.log('swipe: xDown: '+ xDown + '; yDown:' + yDown + '; xUp:' + xUp + '; yUp:' + yUp);
      }
      else{
       console.log('no swipe detected');
        direction = 'no-swipe';
      }
      
  console.log('direction: ' + direction);
      swipeFunctions(direction);
      
        })
    ; 
  
  
  


$(document).ready(function(){


  $('.modal__overlay').click(function(e){
    if($(e.target).hasClass('modal__overlay')){
      closeModal($(this));
    }
  })
  
  $(document).on("DOMSubtreeModified",'#sidebar-cart',function(){
    console.log($(this).find('.Cart__ShippingNotice ').html());
    var noticeHtml = $(this).find('.Cart__ShippingNotice').html();
    $('.FreeShippingNotice').html(noticeHtml);
  })

        $(document).on('click','.gift-trigger',function(){
        $('.gift-form-holder').slideDown(300);
      })
  
    $(document).on('change','.wrapItem',function() {
  var forVal = '';
if($('.wrapItem:checked').length > 0){
      $('.wrapItem:checked').each(function(){
forVal = forVal + ', ' + $(this).val();
      })

      forVal = forVal.replace(', ', '');
      $('.cartWrapAdd').removeClass('disabled');
      $('input[name="properties[For]"]').val(forVal);
      }
      else{
$('input[name="properties[For]"]').val('');
      $('.cartWrapAdd').addClass('disabled');
      }

    $('.prodWrapForm [name="quantity"]').val( $('.wrapItem:checked').length);
      })

  $(document).on('click', '.cartWrapAdd', function(){
    $('.prodWrapForm').submit(); 
  })

  $(document).on('click', '.addFreeGift', function(){
    console.log('adding the gift');
$('.FreeGiftFormHolder.active .FreeGiftForm').submit();
    console.log('gift form submitted');
  })

  $('.horizontal-tab-title').click(function(){
    var index = $(this).data('index');

    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    $(this).parents('.horizontal-tabs-holder').find('.horizontal-tab-body[data-index="'+index+'"]').slideDown();
    $(this).parents('.horizontal-tabs-holder').find('.horizontal-tab-body:not([data-index="'+index+'"])').slideUp();
    
  })

  $(document).on('click', '.expand-swatches', function(){
    $(this).parents('.colours').addClass('swatches-expanded');
  })
})